import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AccordionMenuInputService {
  private breadcrumbShown$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  private clickBreadcrumb$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  private productTypeClicked$: BehaviorSubject<boolean | null> = new BehaviorSubject<boolean | null>(null);

  public setBreadcrumbShown(show: boolean): void {
    this.breadcrumbShown$.next(show);
  }

  public isBreadcrumbShown(): Observable<boolean> {
    return this.breadcrumbShown$.asObservable();
  }

  public setClickBreadcrumb(click: boolean): void {
    this.clickBreadcrumb$.next(click);
  }

  public getClickBreadcrumb(): Observable<boolean> {
    return this.clickBreadcrumb$.asObservable();
  }

  public setProductTypeClicked(click: boolean | null): void {
    this.productTypeClicked$.next(click);
  }

  public isProductTypeClicked(): Observable<boolean | null> {
    return this.productTypeClicked$.asObservable();
  }
}
